import React from "react"
import { connect } from "react-redux"

import FilterWidget from "./FilterWidget"

export default function buildFilterWidgetContainer(
    FilterFormComponent,
    clearFilterCriteriaActionCreator,
    applyFilterCriteriaActionCreator,
    setFilterActionCreator
) {
    const mapStateToProps = () => ({
        children: [<FilterFormComponent key="some-key" />]
    })

    const mapDispatchToProps = dispatch => ({
        clearFilter: () => dispatch(clearFilterCriteriaActionCreator()),
        requestFilterSearch: () => {
            dispatch(applyFilterCriteriaActionCreator())
            dispatch(setFilterActionCreator(false))
        },
        closeFilter: () => dispatch(setFilterActionCreator(false))
    })

    return connect(mapStateToProps, mapDispatchToProps)(FilterWidget)
}
